/**
 * 人工计划
 */
import request from '@/utils/request'

/**
 * 个人计划
 * @param {彩种ident}} loty 
 * @returns 
 */
export function getPlanlaborIndex(loty) {
    return request.post('/index/planlabor',{
        loty: loty
    });
}

export function getIndex2(loty) {
    return request.get('/index/planlabor',{
        params: {
            loty: loty
        }
    });
}

/**
 * [个人计划]获取计划列表
 * @param {*} loty 
 * @returns 
 */
export function getPlanlabor(loty,sort = 0) {    
    return request.post('/index/planlabor/getplan',{
        loty: loty,
        sort: sort //0默认排序 1为按点击量从低到高 2为按点击量从高到低
    });
}

/**
 * [个人计划]详情
 * @param {*} id 
 * @param {*} loty 
 * @param {*} plan_name 
 * @returns 
 */
export function getPlanlaborDetail(id,loty,plan_name = '') {    
    return request.post('/index/planlabor/getPlanDetail',{
        id: id,
        loty: loty,
        plan_name: plan_name
    });
}


/**
 * [个人计划]添加取消收藏
 * @param {*} params 
 * @returns 
 */
export function postPlanlaborCollectplan(params) {   
    let o = {
        loty: '',
        plan_name: '',
        status: 0,//1:收藏 0:取消收藏
        id: 0
    };
    Object.assign(o,params);
    return request.post('/index/planlabor/collectplan',o);
}

/**
 * [个人计划]收藏列表
 * @param {*} loty 
 * @returns 
 */
export function getPlanlaborCollect(loty) {
    return request.post('/planlabor_collect/' + loty);
}


// WEBPACK FOOTER //
// ./src/api/planlabor.js